import {memo} from "react";
import LikeDisLike from "../likeDisLike/likeDisLike";
import { useAppDispatch, useAppSelector } from "redux-share/hooks";
import { conditions, getRemainingTime } from "helpers";
import { ConditionName } from "interfaces";
import OnlineViewersIcon from "../../icon-components/onlineViewerIcon";
import { setSharePopover } from "redux-share/slices/popoversSlice";
import Share1Icon from "../../icon-components/share1Icon";
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const Tags = dynamic(() => import("../tags/tags"));
const ClockIcon = dynamic(() => import("../../icon-components/clockIcon"));
const Bookmark = dynamic(() => import("../bookmark/bookmark"));
const PersonalMarkersPopover = dynamic(() => import("../personalMarkers/personalMarkers"));
const Download = dynamic(() => import("../download/download"));
const Feedback = dynamic(() => import("../feedback/feedback"));
const MovieDetail = dynamic(() => import("../movie/movieDetail/movieDetail"));
const Trailer = dynamic(() => import("../trailer/trailer"));
const Skeleton = dynamic(() => import("../skeleton/skeleton"));
const Comments = dynamic(() => import("../comments/comments"));
const PlayList = dynamic(() => import("../playList/playList"));
const RecommendationList = dynamic(() => import("../recommendationList/recommendationList"));

const ComplexDesktop = () => {

    const dispatch = useAppDispatch();
    const { details, params } = useAppSelector(({ videoData: { details, params, recommendationList, playList, trailer } }) => ({ details, params, recommendationList, playList, trailer }), shallowEqual);
    useAppSelector(({ comments: { canAddComment, commentsCount } }) => ({ canAddComment, commentsCount }), shallowEqual);
    useAppSelector(({ popovers: { feedbackPopover, personalMarkersPopover } }) => ({ feedbackPopover, personalMarkersPopover }), shallowEqual);

    return (
        <div className={`pl-mt-4 ${!conditions(ConditionName.hasSidebar) && "pl-mx-4"}`} style={{height: "max-content"}}>
            <div
                className="pl-flex pl-justify-between pl-items-center pl-text-secondary-800 dark:pl-text-secondary-50">
                <h1 className="pl-text-[14px] pl-font-bold">{details.title}</h1>
                {
                conditions(ConditionName.showVideoViewers) && (
                <div className="pl-flex pl-items-center pl-gap-1">
                    <span className="pl-text-[14px] pl-font-medium">{conditions(ConditionName.isLiveParam) ? details.live_viewers : details.viewers}</span>
                    <OnlineViewersIcon className="pl-stroke-secondary-800 dark:pl-stroke-secondary-50"/>
                </div>
                )}
            </div>
            {conditions(ConditionName.hasTags) &&
                <div className="pl-flex pl-overflow-hidden pl-mt-4 pl-mb-3">
                    <Tags tagId={String(params.id)} usePlace={"DesktopDescription"} tags={details.tag!} />
                </div>
            }
            <div
                className={`pl-flex pl-flex-wrap ${conditions(ConditionName.hasMovieDetails) ? "pl-justify-end" : "pl-justify-between"} pl-items-center pl-my-4 pl-border-b pl-border-secondary-300 dark:pl-border-gray-700 pl-pb-6`}>
                {!conditions(ConditionName.hasMovieDetails) && conditions(ConditionName.showVideoUploadTime) && (
                    <div
                        className="pl-flex pl-items-center pl-gap-1 pl-text-secondary-500 dark:pl-text-gray-400 pl-text-[14px] pl-font-medium">
                        <ClockIcon className="pl-fill-secondary-500 dark:pl-fill-gray-400"/>
                        <span>{getRemainingTime(details.start_time!)}</span>
                    </div>
                )}
                <div className="pl-flex pl-flex-wrap pl-items-center pl-gap-6">
                    {conditions(ConditionName.showBookmark) && <Bookmark />}
                    {conditions(ConditionName.showPersonalMarker) && <PersonalMarkersPopover />}
                    {conditions(ConditionName.hasDownloadLinks) && <Download/>}
                    <LikeDisLike/>
                    <div
                        className={`pl-relative pl-flex pl-items-center pl-gap-3 pl-text-[14px] pl-font-medium pl-text-secondary-700 dark:pl-text-secondary-50 pl-bg-gray-100 dark:pl-bg-dark-3 pl-border-none pl-rounded-[20px] pl-py-[7px] pl-px-3 pl-cursor-pointer`}
                        onClick={() => dispatch(setSharePopover(true))}>
                        <span>اشتراک گذاری</span>
                        <Share1Icon className="pl-fill-secondary-700 dark:pl-fill-secondary-50"/>
                    </div>
                    {conditions(ConditionName.showFeedback) && <Feedback/>}
                </div>
            </div>
            {(conditions(ConditionName.hasMovieDetails) || (conditions(ConditionName.hasDescription) && !conditions(ConditionName.hasTrailer))) && (
                <div className="pl-border-b pl-border-secondary-300 dark:pl-border-gray-700 pl-pb-4">
                    <div className="pl-bg-gray-highLight dark:pl-bg-dark-2 pl-rounded-[16px] pl-px-3 pl-py-4">
                        {conditions(ConditionName.hasMovieDetails) && <MovieDetail />}
                        {conditions(ConditionName.hasDescription) && !conditions(ConditionName.hasTrailer) && <p className="pl-text-[14px] pl-font-normal pl-whitespace-pre-wrap">{details.description}</p>}
                    </div>
                </div>
            )}
            {!conditions(ConditionName.isBeforeRequest) && <Trailer/>}
            {conditions(ConditionName.isBeforeRequest) ?
                    <div className={window.innerWidth < 900 ? "pl-mt-3 pl-w-full" : ""}>
                        {
                            Array.from(Array(2).keys()).map((item, index) => <Skeleton key={index}/>)
                        }
                    </div>
                :
                <>
                    {conditions(ConditionName.showCommentComponent) && <Comments/>}
                    {window.innerWidth < 900 && (
                        <div className="pl-mt-3 pl-w-full">
                            {conditions(ConditionName.hasPlayList) && <PlayList/>}
                            {conditions(ConditionName.hasRecommendationList) && conditions(ConditionName.showRecommendationList) && <RecommendationList/>}
                        </div>
                    )}
                </>
            }
        </div>
    )
}

export default memo(ComplexDesktop);